import { JoinRequestResponse } from '@/lib/definitions/api.types'
import { FLAGS, useFeatureFlag } from '@/lib/hooks/useFeatureFlag'
import { useAuth } from '@/lib/provider/AuthProvider'
import {
  useLoadJoinRequests,
  useLoadMyJoinRequests,
} from '@/lib/queries/Membership.queries'

/** The requests the signed-in user sent that no company has answered yet. */
export const useMyPendingJoinRequests = (): JoinRequestResponse[] => {
  const [auth] = useAuth()
  const isJoinEnabled = useFeatureFlag(FLAGS.COMPANY_JOIN_REQUESTS)
  const { data } = useLoadMyJoinRequests(isJoinEnabled && Boolean(auth.user))

  return data ?? []
}

/** How many people are waiting to be let into the current company. */
export const useIncomingJoinRequestCount = (): number => {
  const [auth] = useAuth()
  const isJoinEnabled = useFeatureFlag(FLAGS.COMPANY_JOIN_REQUESTS)
  const hasCompany = Boolean(auth.user?.customer_id)
  const { data } = useLoadJoinRequests(isJoinEnabled && hasCompany)

  return data?.length ?? 0
}
